import Swiper, { Navigation, Pagination } from 'swiper';

Swiper.use([Navigation, Pagination]);

document.addEventListener("DOMContentLoaded", function (){
	const welcomeSlider = new Swiper('.welcome-slider .swiper-container', {
		loop: true,
		navigation: {
			nextEl: '.welcome-slider__nav-next.swiper-button-next',
			prevEl: '.welcome-slider__nav-prev.swiper-button-prev',
		},
	});

	const servicesSlider = new Swiper('.services-slider .swiper-container', {
		loop: true,
		pagination: {
			el: '.services-slider__pagination.swiper-pagination',
			clickable: true,
		},
		navigation: {
			nextEl: '.services-slider__nav-next.swiper-button-next',
			prevEl: '.services-slider__nav-prev.swiper-button-prev',
		},
	});

	const advantagesSlider = new Swiper('.advantages-slider .swiper-container', {
		loop: true,
		pagination: {
			el: '.advantages-slider__pagination.swiper-pagination',
			clickable: true,
		},
		navigation: {
			nextEl: '.advantages-slider__nav-next.swiper-button-next',
			prevEl: '.advantages-slider__nav-prev.swiper-button-prev',
		},
	})

	const haveTimeSlider = new Swiper('.have-time-slider .swiper-container', {
		loop: true,
		slidesPerView: "auto",
		spaceBetween: 78,
		slidesOffsetBefore: 78,
		navigation: {
			nextEl: '.have-time-slider__nav-next.swiper-button-next',
			prevEl: '.have-time-slider__nav-prev.swiper-button-prev',
		},
	});

	const categoriesSlider = new Swiper('.categories-slider .swiper-container', {
		slidesPerView: 9,
		navigation: {
			nextEl: '.categories-slider__nav-next.swiper-button-next',
			prevEl: '.categories-slider__nav-prev.swiper-button-prev',
		},
	});
})

